/* eslint-disable import/prefer-default-export */

export const localCache = new Map();
